<template>
    <div class="container-banners">
        <div class="container-title-box">
            <div class="title-box-title">
                <span>Всплывающие</span>
                <div @mouseover="openInfo($event)" @mouseleave="showInfo = false">
                    <v-icon color="var(--app-dark-blue-1)">mdi-information</v-icon>
                </div>
            </div>
            <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
                <v-card min-width="300px" min-height="100px">
                    <div class="menu-container">
                        <div class="menu-container-title">
                            Баннеры всплывающие
                        </div>
                        <div class="menu-container-text">
                            Отображаются при входе в мобильное приложение, перекрывая весь контент.
                            Его можно скрыть или перейти по кнопке. Отображается только один раз.
                        </div>
                        <div class="menu-container-title">
                            В колонке статус -
                            <v-icon small color="#929292">
                                mdi-check-circle
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Баннер активный - отображается в мобильном приложении
                        </div>
                        <div class="menu-container-title">
                            В колонке статус -
                            <v-icon small color="#929292">
                                mdi-clock-time-five-outline
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Баннер ожидает публикации
                        </div>
                        <div class="menu-container-title">
                            В колонке статус - пусто
                        </div>
                        <div class="menu-container-text">
                            Баннер неактивный - закончилось время публикации
                        </div>


                    </div>

                </v-card>
            </v-menu>


            <div>
                <v-btn @click="goToCreate" class=" button-accept">
                    + Создать баннер
                </v-btn>
            </div>

        </div>

        <v-tabs class="container-banners-tabs" color="var(--app-dark-blue-1)">
            <v-tab>

                Опубликованные
            </v-tab>
            <v-tab>
                Черновики

            </v-tab>
            <v-tab-item>

                <v-data-table :headers="tableHeaders" :items="bannersActive" item-key="id" :show-select="false"
                    :disable-pagination="true" :hide-default-footer="true">

                    <template v-slot:body="props">
                        <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
                            :style="moveItems ? 'pointer-events: none;' : ''">
                            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
                                <td>
                                    <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                                        mdi-menu
                                    </v-icon>
                                </td>
                                <td style="max-width: 100px !important"> {{ index + 1 }} </td>
                                <td>
                                    <div v-if="checkStatus(item) == 1">
                                        <v-icon color="var(--app-green-1)">mdi-check-circle</v-icon>
                                    </div>
                                    <div v-else-if="checkStatus(item) == 2">
                                        <v-icon>mdi-clock-time-five-outline</v-icon>

                                    </div>
                                    <div v-else-if="checkStatus(item) == 3">

                                    </div>
                                </td>

                                <td> {{ item.title }} </td>
                                <td v-if="item.datePublishStart > 0"> {{ item.datePublishStart | moment("DD.MM.YYYY") }}
                                </td>
                                <td v-else> - </td>
                                <td v-if="item.datePublishEnd > 0"> {{ item.datePublishEnd | moment("DD.MM.YYYY") }} </td>
                                <td v-else> - </td>

                            </tr>
                        </draggable>
                    </template>

                </v-data-table>


            </v-tab-item>


            <v-tab-item>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Заголовок
                                </th>
                                <th class="text-left">
                                    Начало публикации
                                </th>
                                <th class="text-left">
                                    Конец публикации
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(item, index) in bannersDraft" :key="index" @click="goToDetail(item)">
                                <td class="text-left">{{ item.title }}</td>

                                <td v-if="item.datePublishStart > 0"> {{ item.datePublishStart | moment("DD.MM.YYYY") }}
                                </td>
                                <td v-else> - </td>
                                <td v-if="item.datePublishEnd > 0"> {{ item.datePublishEnd | moment("DD.MM.YYYY") }} </td>
                                <td v-else> - </td>

                            </tr>



                        </tbody>
                    </template>
                </v-simple-table>


            </v-tab-item>
        </v-tabs>
    </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    name: "PopUp",
    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        bannersActive: [],
        bannersDraft: [],
        moveItems: false,
        selectedDrag: '',
        tableHeaders: [
            {
                text: '',
                sortable: false
            },
            {
                text: 'Порядковый номер',
                value: '',
                sortable: false
            },
            {
                text: 'Статус',
                sortable: false,
                value: 'status',
            },
            {
                text: 'Заголовок',
                sortable: false,
                value: 'title',
            },
            {
                text: 'Начало публикации',
                sortable: false,
                value: 'datePublishStart',
            },
            {
                text: 'Конец публикации',
                sortable: false,
                value: 'datePublishEnd',
            },
        ],
        timerId: null,
        newIndexList: [],
    }),
    methods: {
        endDrag(evt) {

            this.moveItems = true
            this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/banner/sort', {
                bannerId: this.selectedDrag,
                index: evt.newIndex + 1

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.getActiveBanners()
                    this.moveItems = false


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        checkMove(evt) {
            this.selectedDrag = evt.draggedContext.element.id
        },
        checkStatus(item) {
            const date = new Date().getTime()

            if (date > item.datePublishStart && date < item.datePublishEnd) {

                return 1
            }
            else if (date < item.datePublishStart && date < item.datePublishEnd) {

                return 2
            }
            else if (date > item.datePublishStart && date > item.datePublishEnd) {

                return 3
            }
        },
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true

        },
        goToDetail(item) {
            this.$router.push({ name: 'PopUpBannersDetail', params: { id: item.id } })
        },
        goToCreate() {
            this.$router.push({ name: 'PopUpBannersCreate' })
        },
        getActiveBanners() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/banner/list', {
                type: 'pop-up',
                status: 'active'

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.bannersActive = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })


        },
        getDraftBanners() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/banner/list', {
                type: 'pop-up',
                status: 'draft'

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.bannersDraft = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },


    },
    watch: {


    },
    created() {
        this.getActiveBanners()
        this.getDraftBanners()
    }

}
</script>
<style lang="scss" scoped>
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row),
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>div>tr:not(:last-child)>th:not(.v-data-table__mobile-row) {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.v-data-table>.v-data-table__wrapper>table>tbody>div>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
    font-size: 0.875rem;
    height: 48px;
}

.v-tab {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: normal;
    font-weight: 400;

}

.menu-container {
    width: 400px;
    box-sizing: border-box;
    padding: 16px;

    .menu-container-title {
        font-size: 16px;
        font-weight: 600;
        color: #929292;
    }

    .menu-container-text {
        font-size: 16px;
        font-weight: 400;
        width: 330px;
    }
}

.container-banners {

    .container-title-box {
        box-sizing: border-box;
        padding: 40px 24px 0 24px;
        display: flex;
        margin-bottom: 40px;
        justify-content: space-between;
        align-items: center;

        .title-box-title {
            display: flex;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                margin-right: 20px;
            }

        }
    }

    .container-banners-tabs {}
}
</style>